import { getImagePath, defaultPost } from '@bikemap/js/utility'
import { context, gettext, modals, notifications } from '@bikemap/js/services'
import actions from './actions'

/**
 * TODO: Replace this context workaround by imports, when functions and constants are extracted into modules!
 */
let initDZRemoveButtons
export function initProfileSettingsContext(context) {
    initDZRemoveButtons = context.initDZRemoveButtons
}

function handleDeleteConfirm(modal, url, onSuccess) {
    modal.setLoading()

    const body = new FormData
    body.append('deleteImage', 1)
    defaultPost(url, body)
        .then(res => {
            if (res.status === 'success') {
                onSuccess()
                initDZRemoveButtons()
                notifications.show({
                    title: res.title,
                    message: res.msg,
                    icon: 'i-check',
                    type: 'success',
                })
            }
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

function handleProfilePictureDeleteConfirm(e, modal) {
    const url = context.page('profileBaseUrl') + 'settings/delete-avatar/'
    const handleSuccess = () => {
        actions.setNoCustomAvatar()
        const profileImages = document.querySelectorAll('.profile-avatar')
        for (let i = 0; i < profileImages.length; i++) {
            profileImages[i].setAttribute('src', getImagePath('default_avatar.png'))
        }
    }
    handleDeleteConfirm(modal, url, handleSuccess)
}

export function showProfilePictureDeleteModal() {
    modals.show('profile-picture-delete', {
        title: gettext('Delete profile picture'),
        message: gettext('Do you really want to delete your profile picture?'),
        buttons: [
            { content: gettext('Cancel'), action: 'close' },
            { content: gettext('Confirm'), style: 'danger', action: 'submit' },
        ],
        onSubmit: handleProfilePictureDeleteConfirm,
    })
}

function handleCoverPictureDeleteConfirm(e, modal) {
    const url = context.page('profileBaseUrl') + 'settings/delete-cover/'
    const handleSuccess = () => {
        actions.setNoCustomCover()
        const profileCoverPlaceholderURL = getImagePath('placeholder-users.jpg')
        const profileCover = document.querySelector('#profile-cover > img')
        // We need to remove the srcset-attribute to disable responsive behaviour
        // placeholder is in full resolution, so one source suffices
        profileCover.removeAttribute('srcset')
        profileCover.setAttribute('src', profileCoverPlaceholderURL)
        document.querySelector('#dropzone-cover-picture-img').setAttribute('src', profileCoverPlaceholderURL)
    }
    handleDeleteConfirm(modal, url, handleSuccess)
}

export function showCoverPictureDeleteModal() {
    modals.show('cover-picture-delete', {
        title: gettext('Delete cover picture'),
        message: gettext('Do you really want to delete your cover picture?'),
        buttons: [
            { content: gettext('Cancel'), action: 'close' },
            { content: gettext('Confirm'), style: 'danger', action: 'submit' },
        ],
        onSubmit: handleCoverPictureDeleteConfirm,
    })
}
